import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView, BaseText } from '@/components/base'
import { Modal } from '@/components/Modal'
// Используем CurrencyItem из add-money вместо общего компонента
import { CurrencyItem } from '@/features/add-money/select-currency/components/CurrencyItem'
import { useUserStore } from '@/store'

interface ConversionCurrencyBottomSheetProps {
  isOpen: boolean
  onClose: () => void
  onCurrencySelect: (currency: any) => void
  excludeCurrencies: string[]
  type: 'from' | 'to'
}

export const ConversionCurrencyBottomSheet: React.FC<
  ConversionCurrencyBottomSheetProps
> = ({ isOpen, onClose, onCurrencySelect, excludeCurrencies, type }) => {
  const { t } = useTranslation()
  const completeCurrencies = useUserStore(
    (state) => state.wallet?.completeCurrencies,
  )

  // Фильтруем валюты - исключаем уже выбранные
  const availableCurrencies = (completeCurrencies || []).filter(
    (currency) => !excludeCurrencies.includes(currency.code),
  )

  const handleCurrencySelect = (currency: any) => {
    onCurrencySelect(currency)
  }

  const getTitle = () => {
    if (type === 'from') {
      return t('screens:conversion.selectFromCurrency', 'Select Currency')
    }
    // Изменяем текст для "to" типа
    return t('screens:conversion.selectToCurrency', 'Select Currency')
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={getTitle()}
      showHandle={true}
      useBottomOffset={true}
    >
      <BaseView
        style={{
          gap: 12,
          paddingBottom: 20,
        }}
      >
        {availableCurrencies.map((currency) => (
          <CurrencyItem
            key={currency.id}
            {...currency}
            onPress={() => handleCurrencySelect(currency)}
          />
        ))}

        {availableCurrencies.length === 0 && (
          <BaseView center py={32}>
            <BaseText color="label.description">
              {completeCurrencies?.length === 0
                ? t(
                    'screens:conversion.loadingCurrencies',
                    'Loading currencies...',
                  )
                : t(
                    'screens:conversion.noCurrenciesAvailable',
                    'No currencies available',
                  )}
            </BaseText>
          </BaseView>
        )}
      </BaseView>
    </Modal>
  )
}
